import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/components/ui/Button';
import { URLS } from 'configs';
import './CTASection.scss';

const CTASection = () => {
  const { t } = useTranslation();

  return (
    <section className='cta-section'>
      <div className='cta-section__container'>
        <div className='cta-section__banner'>
          <div className='cta-section__content'>
            <div className='cta-section__badge'>
              <Sparkles size={20} aria-hidden='true' />
            </div>
            <h2 className='cta-section__title'>{t('cta_title')}</h2>
            <p className='cta-section__description'>{t('cta_description')}</p>
            <div className='cta-section__buttons'>
              <a href={URLS.CONTACT} className='cta-section__button-link'>
                <Button variant='hero' size='xl' className='cta-section__button'>
                  {t('contact_us', 'Contact us')}
                  <ArrowRight size={20} />
                </Button>
              </a>
              <Link to='/contact'>
                <Button variant='outline' size='xl' className='cta-section__button cta-section__button--outline'>
                  {t('cta_contact_sales')}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
